export default [
    {
        title: 'Temperatura',
        fontIcon: 'temperature-half',
        resource: 'Temperatura',
        action: 'ver-temperatura-produccion',
        children: [
            {
                title: 'Dashboard',
                icon: 'ClipboardIcon',
                resource: 'Temperatura',
                route: 'temperatura-produccion-dashboard',
                action: 'ver-temperatura-produccion-dashboard',
            },
            {
                title: 'Dashboard mantenimiento',
                icon: 'ClipboardIcon',
                resource: 'Temperatura',
                route: 'temperatura-produccion-dashboard-mantenimiento',
                action: 'ver-temperatura-produccion-dashboard-mantenimiento',
            },
            {
                title: 'Configuracion',
                icon: 'SettingsIcon',
                resource: 'Temperatura',
                action: 'ver-temperatura-produccion-configuracion',
            },
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Temperatura',
                action: 'ver-temperatura-produccion-mantenimiento',
            },
            {
                title: 'Transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Temperatura',
                action: 'ver-temperatura-produccion-transacciones',
            },
            {
                title: 'Informes',
                fontIcon: 'file-prescription',
                resource: 'Temperatura',
                route: 'temperatura-produccion-informes',
                action: 'ver-temperatura-produccion-informes',
            },
        ],
    },
]
